import { Ability } from '@casl/ability';
import { forEach } from 'lodash';
import { Ability as AbilityObject } from '@/models/Ability';
import getJSONFromLocalStorage from '@/utils/getJSONFromLocalStorage';
import { PersistedUser } from '@/models/User';
import Permissions from './permissions';

// CASL initializes at module load, before the Vuex store hydrates, so it seeds
// itself directly from the persisted user object in localStorage. The live
// ability is refreshed on login via updatePermissions().
const persistedUser: PersistedUser | null = getJSONFromLocalStorage('user');
const userRoles = persistedUser?.roles ?? [];
const userPermissions = persistedUser?.permissions ?? [];

function createPermissions(roles: string[], permissions: string[]) {
  const allPermissions = [] as AbilityObject[];

  if (roles) {
    forEach(roles, (role) => {
      if (Permissions.rolePermissions[role]) {
        allPermissions.push(...Permissions.rolePermissions[role]);
      }
    });
  }

  if (permissions) {
    forEach(permissions, (permission) => {
      if (Permissions.additionalPermissions[permission]) {
        allPermissions.push(...Permissions.additionalPermissions[permission]);
      }
    });
  }

  return allPermissions;
}

export default new Ability([
  ...(createPermissions(userRoles, userPermissions)),
]);
